import React, { useState, useEffect } from "react";
import ProductCards from "../ProductCards/ProductCards";
import styles from "./productGridList.module.scss";
import labels from "../../../config/labels";
import {
  getPromotionLabel,
  getPromotionVariant,
  componentCheckSize,
  getProductImageUrl,
  getHighlights,
  showSpinner,
  hideSpinner,
} from "../../../utils/helperServices";
import {
  checkIsLowStock,
  checkIsOutOfStock,
  checkIsFinalPriceReq,
  getFinalPrice,
  getPercentOffValue,
  getAmountOffValue,
  getRegularPrice,
  urlPrefix,
} from "../../../utils/helperServices";
import DealCard from "../dealCard/DealCard";
import { useRouter, Link } from "../../atoms/DependencyHelper";
import OrderHistoryLoadMore from "../viewOrderHistory/orderHistoryLoadMore/OrderHistoryLoadMore";
import ajaxServices from "../../../utils/ajaxServices";

const ProductGridList = (props) => {
  const [gridItems, setGridItems] = useState([]);
  const pageSize = props?.component?.numOfProducts || 12;
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const isMobile = componentCheckSize() <= 576;
  const isTabletLandscape = componentCheckSize() > 992;
  const router = useRouter();
  useEffect(() => {
    showSpinner();
    ajaxServices
      .fetchGraphQLGetRequest(
        (props?.component?.API?.apiEndpoint || "")
          .replace(
            "<productSku>",
            props?.component?.productCategory?.join('","')
          )
          .replace("<pageSize>", pageSize)
          .replace("<currentPage>", page)
          .split("=")[1]
      )
      .then((response) => {
        const items =
          page === 1
            ? response.products.items || []
            : [...gridItems, ...(response.products.items || [])];
        setTotalItems(response.products.total_count);
        setGridItems(items);
      })
      .catch(() => {
        setGridItems([]);
      })
      .finally(() => hideSpinner());
  }, [page]);
  if (!gridItems.length) {
    return null;
  }
  return (
    <>
      <div
        className={`${styles["grid-container"]} ${
          isMobile ? styles["grid-container__mobile"] : ""
        }`}
      >
        {gridItems.map((item, index) => (
          <div
            className={
              !props.isDeal
                ? styles["carousel-container"]
                : styles["carousel-container-deal"]
            }
            key={index}
          >
            {props.isDeal ? (
              <Link legacyBehavior
                href={{
                  pathname: `${urlPrefix}/deal-details-page/${item.sku}`,
                  query: { contractSkus: item.sku },
                }}
              >
                <a className={styles["dealcard-link"]}>
                  <DealCard
                    width="100%"
                    height="32.938rem"
                    img_width="10rem"
                    maxHeight="33.5rem"
                    img_height="10rem"
                    width_mobile="17.5rem"
                    height_mobile="29.313rem"
                    img_width_mobile="7.5rem"
                    img_height_mobile="7.5rem"
                    productName={item?.name}
                    availableIn={props?.availableIn}
                    endsIn={props?.endsIn}
                    imgUrl={getProductImageUrl(item, "image", "No_image")}
                    imgUrl_mobile={getProductImageUrl(
                      item,
                      "small_image",
                      "No_image_1"
                    )}
                    saveLabel={
                      item?.price_range?.minimum_price?.discount?.amount_off !=
                        0 &&
                      item?.price_range?.minimum_price?.discount?.amount_off
                    }
                    promotionLabel={item?.promotion_tag !=null ? getPromotionLabel(item) : ''}
                    promotionVariant={getPromotionVariant(item)}
                    promotionLabelColor={
                      getPromotionLabel(item) === item?.promotion_tag_label
                        ? item.promotion_tag_swatch
                        : item?.badges_swatch
                        ? item.badges_swatch
                        : null
                    }
                    planName={
                      item.package_description ? item.package_description : ""
                    }
                    highlights={getHighlights(item)}
                    originalPrice={
                      item?.monthly_recurring ? item.monthly_recurring : ""
                    }
                    offerPrice={
                      item?.monthly_recurring ? item.monthly_recurring : ""
                    }
                    prevPrice={
                      item?.old_monthly_recurring
                        ? item.old_monthly_recurring
                        : ""
                    }
                    numberOfMonths={item?.payment_terms_label}
                    buttonText={labels.lbl_see_details}
                    deal_end_date={item?.deal_end_date}
                    deal_go_live_date={item?.deal_go_live_date}
                    deal_label={item?.deal_label}
                    is_deal_locked={item?.is_deal_locked}
                    item={item}
                    id={item?.sku}
                  />
                </a>
              </Link>
            ) : (
              <ProductCards
                priceRequired
                promotionLabel={item?.promotion_tag != null ? getPromotionLabel(item) : ''}
                promotionVariant={getPromotionVariant(item)}
                promotionLabelColor={
                  getPromotionLabel(item) === item?.promotion_tag_label
                    ? item.promotion_tag_swatch
                    : item?.badges_swatch
                    ? item.badges_swatch
                    : null
                }
                maximumPrice={
                  item?.price_range?.maximum_price?.regular_price?.value
                }
                minimumPrice={
                  getAmountOffValue(item) === "0"
                    ? getFinalPrice(item) !== "0"
                      ? getFinalPrice(item)
                      : getRegularPrice(item)
                    : getRegularPrice(item)
                }
                isLowStock={checkIsLowStock(item)}
                isOutOfStock={checkIsOutOfStock(item)}
                finalPriceReq={checkIsFinalPriceReq(item)}
                finalPrice={getFinalPrice(item)}
                percentOff={getPercentOffValue(item)}
                amountOff={getAmountOffValue(item)}
                offerStyle={styles["offer-style"]}
                priceLabelProductStyle={styles["price-label-style"]}
                itemName={item?.name}
                buyNowReq
                itemImage={item?.image.url}
                buttonLabelReq={labels.lbl_buy_now}
                previousPriceReq
                sku={item?.sku}
                isPrepaidOnly={
                  item?.bundle_product_price === null ||
                  item?.bundle_product_price === undefined
                }
                dealProductPrice={item?.bundle_product_price}
                switchClass="product-carousel"
                cardWidth={isTabletLandscape ? props.width : props.width_mobile}
                imgWidth={
                  isTabletLandscape ? props.img_width : props.img_width_mobile
                }
                imgHeight={
                  isTabletLandscape ? props.img_height : props.img_height_mobile
                }
                priceLabelClassName={styles["card-price-height"]}
                deal_end_date={item?.deal_end_date}
                deal_go_live_date={item?.deal_go_live_date}
                deal_label={item?.deal_label}
                is_deal_locked={item?.is_deal_locked}
                item={item}
                id={item?.sku}
              />
            )}
          </div>
        ))}
      </div>
      <OrderHistoryLoadMore
        totalPages={Math.ceil(totalItems / pageSize)}
        pageNumber={page}
        onLoadMore={() => setPage((currentPage) => currentPage + 1)}
        buttonLabel={
          props.isDeal
            ? labels.lbl_show_more_deals
            : labels.lbl_show_more_products
        }
      />
    </>
  );
};

export default ProductGridList;
